export const InviteType = {
  count: 13,
  payment: 12,
  login: 21
}

export const VipStatusTypeNameMap = {
  'PAYMENT': 'siteBuild.payment',
  'REDEEM': 'siteBuild.redeem',
  'UPGRADE': 'siteBuild.upgrade',
  'REFUND': 'siteBuild.refund'
}

export const BusEventMap = {
  Payment: 'payment',
  LoginOut: 'login-out',
  Login: 'login',
}

export const TypeData = {
  recharge: 'recharge',
  rollingOffer: 'rollingOffer'
}

export const VisitCountryTypeEnum = {
  Whitelist: 'whitelist',
  Blacklist: 'blacklist'
}

export const LayoutPositionEnum = {
  BottomLeft: 'bottom-left',
  BottomRight: 'bottom-right',
}

export const CustomerLayoutOptionsEnum = [
  {
    label: '左下角',
    value: LayoutPositionEnum.BottomLeft
  },
  {
    label: '右下角',
    value: LayoutPositionEnum.BottomRight
  }
]

export const AccumulationLayoutEnum = {
  Row: 'row',
  Col: 'col'
}

export const AccumulationColLayoutSizeEnum = {
  Three: 3,
  Four: 4
}

export const CustomerServiceTypeEnum = {
  AIHelp: 'ai_help'
}

export const CustomerServiceSystemEnum = [
  {
    label: 'AIHelp',
    value: CustomerServiceTypeEnum.AIHelp,
  }
]

export const CustomerSdkEnums = {
  [CustomerServiceTypeEnum.AIHelp]: 'https://cdn.aihelp.net/webchatv5/aihelp.js'
}

export const MissionCenterTypeEnums = {
  PwaLogin: 100001
}

export const QuenUnlockStatusEnum = {
  Free: 'free',
  Priced: 'priced',
  Purchased: 'purchased',
  Claimed: 'claimed'
}
